module.exports = __webpack_public_path__ + "img/GR.d8492b8a.svg";